import {safeURL, plainText} from './api-data.js';

export function workOptions(mode, limit) {
    mode = mode?.toLowerCase() === 'detail' ? 'Detail' : 'Summarize';
    const count = Number(limit);
    return {mode, limit: Number.isInteger(count) && count >= 1 && count <= 30 ? count : mode === 'Detail' ? 15 : 4};
}
export function workKey(item, mode) { return mode === 'Detail' ? `${item.repo}:${item.sha}` : item.repo; }
export function workDate(item, mode) { return mode === 'Detail' ? item.committed_at : item.last_active_at; }
export function workDay(date) { return new Date(date).toISOString().slice(0, 10); }

export function workItems(response, {mode, limit}) {
    const items = mode === 'Detail' ? response?.commits : response?.projects;
    if (!['ready', 'stale'].includes(response?.status) || response.mode !== mode || !Array.isArray(items)) throw new Error('Invalid work status response');
    const valid = items.filter(item => item && typeof item.repo === 'string' && item.repo.trim() && safeURL(item.url) &&
        typeof workDate(item, mode) === 'string' && /(?:Z|[+-]\d{2}:\d{2})$/.test(workDate(item, mode)) && Number.isFinite(Date.parse(workDate(item, mode))) &&
        (mode !== 'Detail' || (typeof item.sha === 'string' && /^[a-f0-9]{40}$/i.test(item.sha))));
    if (items.length && !valid.length) throw new Error('No valid work items in response');
    valid.sort((a, b) => Date.parse(workDate(b, mode)) - Date.parse(workDate(a, mode)) || a.repo.localeCompare(b.repo) || (a.sha || '').localeCompare(b.sha || ''));
    const unique = new Map();
    valid.forEach(item => {
        const key = workKey(item, mode);
        if (!unique.has(key)) unique.set(key, item);
    });
    return [...unique.values()].slice(0, limit);
}
// The API retains summary/highlights; the compact view shows just one headline.
export function workHeadline(headline, repo, mode) {
    const text = plainText(headline);
    if (mode === 'Detail') return text;
    for (const prefix of [repo, repo.split('/').at(-1)]) {
        if (text.startsWith(prefix)) {
            const rest = text.slice(prefix.length);
            if (/^(?:\s+|[:：]\s*)/.test(rest) && rest.trim()) return rest.replace(/^(?:\s*[:：]\s*|\s+)/, '') || text;
        }
    }
    return text;
}
